import * as actionTypes from "./actionTypes";
import * as actions from './index';


export const updateShareObjectsSuccess = (data) => {
    return {
        type: actionTypes.SHARE_UPDATE_SHAREOBJECTS_SUCCESS,
        payload: data
    }
}

export const updateShareObjects = (obj) => {
    return (dispatch) => {
        dispatch(actions.updateShareObjectsSuccess(obj));
    }
}

export const setInitShareObjects = () => {
    return {
        type: actionTypes.SHARE_SET_INIT_SHAREOBJECTS
    }
}

export const setHistoryLoading = (data) => {
    return {
        type: actionTypes.SHARE_SET_LOADING,
        payload: data
    }
}




